export default {
  user: false,
  token: sessionStorage.getItem("user-token") || "",
  login: {},
  register: {},
  report: {
    patientData: {},
    medicalData: {},
    findings: {},
    attachments: {
      folderId: "",
      folderFilesCount: 0,
    },
  },
  reportList: {},
  reportTable: {},
  navTop: [
    { auth: false, link: "/rejestracja", desc: "Zarejestruj się", icon: "laptop" },
    { auth: false, link: "/zaloguj-sie", desc: "Zaloguj się", icon: "signIn" },
    { auth: true, link: "/zgloszenia", desc: "Moje zgłoszenia", icon: "envelope", class: "opacity-50" },
    { auth: true, link: "/tabela-zgloszen", desc: "Tabela zgłoszeń", icon: "list" },
    { auth: null, link: "/kontakt", desc: "Kontakt", icon: "phone" },
    { auth: true, link: "/wyloguj-sie", desc: "Wyloguj", icon: "signIn" },
  ],
  navMain: [
    { auth: null, link: "/", desc: "O projekcie", onlyForDoctors: false },
    { auth: true, link: "/osrodek-referencyjny", desc: "Ośrodek referencyjny", onlyForDoctors: false },
    { auth: true, link: "/zglos-przypadek", desc: "Zgłoś przypadek", onlyForDoctors: true },
  ],
  voivodeships: [
    "Dolnośląskie",
    "Kujawsko-Pomorskie",
    "Lubelskie",
    "Lubuskie",
    "Łódzkie",
    "Małopolskie",
    "Mazowieckie",
    "Opolskie",
    "Podkarpackie",
    "Podlaskie",
    "Pomorskie",
    "Śląskie",
    "Świętokrzyskie",
    "Warmińsko-Mazurskie",
    "Wielkopolskie",
    "Zachodniopomorskie",
  ],
};
